import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {forkJoin, Observable, of} from 'rxjs';
import {Globals} from '../globals';
import {ConfigData} from '../../data/models/config.model';
import {map} from "rxjs/operators";
import {LocaleService} from "./locale.service";
import {DateAdapter} from "@angular/material/core";
import {isPlatformBrowser} from "@angular/common";

@Injectable({providedIn: 'root'})
export class ConfigService {
  private http = inject(HttpClient);
  private localeService = inject(LocaleService);
  private dateAdapter = inject<DateAdapter<any>>(DateAdapter);
  private platformId = inject(PLATFORM_ID);

  config:{[key:string]: ConfigData} = {};
  private isBrowser!: boolean

  constructor() {
    const platformId = this.platformId;

    this.isBrowser = isPlatformBrowser(platformId);
  }

  getConfig(type: string): ConfigData | undefined {
    if(!Object.keys(this.config).includes(type)) {
      console.warn(`could not load config '${type}'`);
    }

    return this.config[type];
  }

  loadConfig(type: string, forceReload: boolean = false): Observable<ConfigData> {
    // ggf. unteren request abspeichern und evtl. den zurückgeben?
    if (!forceReload && this.config[type]) {
      return of(this.config[type]);
    }

    let baseData = null;
    if(!forceReload && this.isBrowser)  {
      baseData = JSON.parse(localStorage.getItem('config_' + type));
    }
    if (!forceReload && baseData && new Date(baseData.expirationDate) > new Date()) {
      // Wenn das als JSON reinkommt hat das nicht den korrekten prototype, deswegen einmal klonen
      this.config[type] = ConfigData.clone(baseData.data);
      return of(this.config[type]);
    }
    return this.http.get<ConfigData>('/webabo/configs/' + type).pipe(map(data => {
      // Wenn das als JSON reinkommt hat das nicht den korrekten prototype, deswegen einmal klonen
      this.config[type] = ConfigData.clone(data);
      const expirationDate = new Date();
      expirationDate.setSeconds(expirationDate.getSeconds() + Globals.CACHE_TIME_BASE_DATA);
      if( this.isBrowser) {
        localStorage.setItem('config_' + type, JSON.stringify({expirationDate, data}));
      }
      return this.config[type];
    }));
  }

  loadConfigs(types: string[]): Observable<ConfigData[]> {
    if (types.length === 0) {
      return of([]);
    }
    return forkJoin(types.map(type => this.loadConfig(type)));
  }

  clearConfig() {
    if (this.isBrowser) {
      for (let item in localStorage) {
        if (item.includes('config_')) {
          localStorage.removeItem(item);
        }
      }
    }
  }

  initLocale() {
    if (this.isBrowser) {
      return new Promise((r) => {
        this.loadConfig('locale').toPromise().then((res) => {
          const locale = res?.value?.split('_');
          if (locale) {
            this.dateAdapter.setLocale(locale[0]);
          } else {
            console.error('Error while setting locale');
          }
          r(this);
        });
      });
    }
  }

  initDefaultCountry() {
    if (this.isBrowser) {
      return new Promise((r) => {
        this.loadConfig('requiredFields.addr.defaultCountry').toPromise().then((res) => {
          this.localeService.setDefaultCountry(res.value);
          r(this);
        });
      });
    }
  }
}
